import { render, staticRenderFns } from "./EditorHeaderHelpCenter.vue?vue&type=template&id=6c364d94&"
import script from "./EditorHeaderHelpCenter.vue?vue&type=script&lang=js&"
export * from "./EditorHeaderHelpCenter.vue?vue&type=script&lang=js&"
import style0 from "./EditorHeaderHelpCenter.vue?vue&type=style&index=0&id=6c364d94&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports